import { LoaderContainer, RotatingLoader } from './Loading.styles';

interface LoadingProps {
    position?: 'absolute' | '';
    size?: number;
}

export const Loading = (props: LoadingProps) => {
    const { position, size } = props;
    const borderSize = size ? (size / 100) * 8 : 8;

    return (
        <LoaderContainer>
            <RotatingLoader
                $position={position ?? 'absolute'}
                $size={size ?? 100}
                $borderSize={borderSize}
            />
        </LoaderContainer>
    );
};

export default Loading;
